import { makeStyles } from "@fluentui/react-components";

export const useLocalStyles = makeStyles({
  similarClauseRedlineCard: {
    width: "100%",
    backgroundColor: "transparent",
    padding: 0,
    display: "flex",
    flexDirection: "row",
    columnGap: "6px",
    justifyContent: "flex-start",
    alignContent: "center",
  },
  renderSuggestionContainer: {
    paddingRight: "5px",
    paddingLeft: "1px",
    marginBottom: "15px",
  },
  virtuoso: {
    margin: "0 10px",
  },
});
